import AIPromptsForm from '@features/AIPropmts/ui/AIPromptsForm';
import Box from '@mui/material/Box';

function AIPrompts() {
  return (
    <Box display="flex" flexGrow={1} flexDirection="column">
      <AIPromptsForm />
    </Box>
  );
}

export default AIPrompts;
